import React, { type ReactElement } from 'react';
import Spinner from '@atlaskit/spinner';
import { useProductsJswConfigurationResource } from '@atlassian/jira-products-jsw-configuration-main/src/services';
import { ProductsJswConfiguration } from '@atlassian/jira-products-jsw-configuration-main/src/ui/index.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import SpaErrorBoundary from '@atlassian/jira-spa-apps-common/src/error-boundary';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { JSWConfigurationPageLoad } from './utils/performance-analytics';

const APP_NAME = 'products-jsw-configuration';

export const ProductsJswConfigurationDirectory: () => ReactElement = () => {
	const { data, loading } = useProductsJswConfigurationResource();

	if (loading || data == null) {
		return <Spinner />;
	}

	return (
		<>
			<ProductsJswConfiguration />
			{/* @ts-expect-error - TS2769 - No overload matches this call. */}
			<SubmitApdex appName={APP_NAME} metric={JSWConfigurationPageLoad} />
		</>
	);
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<>
		<MarkProductStart />
		<SpaErrorBoundary id="spa-app-bootstrap.directories.products-jsw-configuration">
			<ProductsJswConfigurationDirectory />
		</SpaErrorBoundary>
	</>
);
